import { apiClient } from './apiClient';
const UserLogin = (mobile: string) =>
  apiClient(`/retailer_app.api.login.generate_and_send_otp?phone_no=${mobile}`, 'GET');

const VerifyOtp = (phone: string, otp: string, fcm_token: string) =>
  apiClient(`/retailer_app.api.login.verify_otp_and_login?phone_no=${phone}&otp=${otp}&fcm_token=${fcm_token}`, 'GET');

const Logout = () => apiClient('/retailer_app.api.login.logout');

export const AuthService = {
  UserLogin,
  VerifyOtp,
  Logout,
};
